<template>
  <div>
    <form ref="searchForm" @submit.prevent="searchUser">
      <div class="row mx-0">
        <div>
          <div class="d-flex justify-content-center align-items-center gap-3">
            <div>
              <b-form-group :label="label">
                <b-form-input
                  :disabled="!!userDetails"
                  type="text"
                  v-model="searchForm.query"
                  placeholder="Enter name or phone"
                />
              </b-form-group>
              <span class="error">{{ searchErrors.query }}</span>
              <span v-if="!userDetails && reservationErrors" class="error">{{
                reservationErrors.user
              }}</span>
              <div v-if="suggestedUsers && suggestedUsers.length">
                <!-- User Details -->
                <div v-if="userDetails" class="user-details mt-1">
                  User:
                  <b>
                    {{
                      (userDetails.name || " No Name ") +
                        " - " +
                        (userDetails.phone || userDetails.email || "")
                    }}</b
                  >
                </div>

                <ul v-else class="suggested-users-wrapper list list-group">
                  <li
                    class="list-group-item"
                    v-for="(u, index) in suggestedUsers"
                    :key="index"
                    @click="() => selectUser(u)"
                  >
                    {{
                      (u.name || " No Name ") +
                        " - " +
                        (u.phone || u.email || "")
                    }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="mt-2 ml-2">
              <b-button
                v-if="userDetails"
                type="button"
                variant="warning"
                @click="resetSearch()"
              >
                <i class="las la-sync fa-lg"></i>
              </b-button>
              <b-button v-else type="submit" variant="primary">
                <i class="las la-search fa-lg"></i>
              </b-button>
              <b-button
                v-if="showAddUser"
                type="button"
                @click="isCreateUser = !isCreateUser"
                variant="primary"
                class="ml-2"
              >
                <i class="las la-user-plus fa-lg"></i>
              </b-button>
            </div>
          </div>
        </div>
        <!-- Create User -->
        <div
          v-if="isCreateUser"
          class=" iq-card-body iq-card col-sm-4 px-0 rm-px5 quick-add"
        >
          <b-button
            variant="warning"
            class="ml-2"
            @click="isCreateUser = false"
          >
            <i class="fas fa-times"></i>
          </b-button>

          <Create
            :in-list="false"
            :business-id="businessId"
            @onSubmit="
              () => {
                isCreateUser = false;
              }
            "
          />
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { searchUser } from "@/API/UsersAPIs";
import { submitAndNotify } from "@/helpers/utils";
import Create from "../Users/Create.vue";

export default {
  name: "SearchUsersForm",
  components: { Create },
  props: {
    businessId: {
      type: Number,
      default: null
    },
    reservationErrors: {
      type: Object | Array,
      default: null
    },
    showAddUser: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: "Name / Phone"
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isCreateUser: false,
      userDetails: null,

      suggestedUsers: [],
      searchForm: {
        query: ""
      },
      searchErrors: {
        query: ""
      }
    };
  },
  methods: {
    async searchUser() {
      this.searchErrors.query = "";
      if (this.isRequired && !this.searchForm.query)
        return (this.searchErrors.query = "This field is required, ");
      if (!this.searchForm.query) return;

      const searchData = {
        businessId: this.businessId,
        search: this.searchForm.query
      };

      const callback = response => {
        this.suggestedUsers = response.data;
      };

      const errorMessage = "No user found with " + this.searchForm.query;

      submitAndNotify(this, searchUser(searchData), callback, "", errorMessage);
    },
    resetSearch() {
      this.userDetails = null;
      this.suggestedUsers = null;
      this.searchForm.query = "";
      this.$emit("setUser", null);
    },
    selectUser(user) {
      if (!user) return;
      this.userDetails = user;
      this.$emit("setUser", user);
    }
  }
};
</script>

<style scoped>
.user-details {
  background: #fff;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.suggested-users-wrapper {
  position: absolute;
  background: #fff;
  max-width: 300px;
  opacity: 0.9;
  z-index: 1000;
}
.quick-add {
  position: absolute;
  right: 0;
  z-index: 3;
}
</style>
